import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FeedbackStudentsPreviewModel } from 'common/models/page-models/Feedback students preview/feedback-students-preview-data-model';
import { FeedbackPreviewModel } from 'common/models/page-models/feedback-preview/feedback-preview-data-model';
import { FormResolverService } from 'common/resolvers/core-resolvers/form-resolver';
import { SystemService } from 'common/services/core-services/system.service';
import { FeedbackStudentFormWidgetService } from 'common/widget/feedback-mapping/feedback-student-form-widget.service';

@Injectable({
    providedIn: 'root',
})
export class FeedbackStudentsFormResolver extends FormResolverService<FeedbackStudentsPreviewModel> {
    constructor(
        protected fs: FeedbackStudentFormWidgetService,
        protected override router: Router,
        protected override systemService: SystemService
    ) {
        super(fs, router, systemService);
    }

    override modifyResponseData(dataModel: any, meta: any, widget: any) {
        const previewModel = new FeedbackPreviewModel();
        // console.log(widget.transferData.transferData.student_id);
        previewModel['student_id'] = widget.transferData.transferData.student_id;
        previewModel['feedbackFormId'] = widget.transferData.transferData.feedback_Form_Id;
        previewModel['feedbackFormMappingId'] = widget.transferData.transferData.feedback_form_mapping_id;
        dataModel.questions.forEach((question) => {
            //console.log(question);
            previewModel[question.id] = null;
        });
        return previewModel;
    }
}